import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateCoverPhotoModal.css';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes';

export interface CreateCoverPhotoProps {
    show: boolean;
    onClose: any;
    createCrop(cropName: string, formData: FormData): void;
}

export interface CreateCoverPhotoState {
    formData: FormData;
    cropName: string;
    hasRequiredFields: boolean;
}

export default class CreateCoverPhotoModal extends React.Component<CreateCoverPhotoProps, CreateCoverPhotoState> {

    constructor(props: any) {
        super(props);

        this.state = {
            formData: new FormData(),
            cropName: '',
            hasRequiredFields: false,
        };
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        var newCropName = (nextProps.crop) ? nextProps.crop.name : '';
        this.setState({
            cropName: newCropName,
            hasRequiredFields: newCropName.length > 0
        });
      }

    handleChangeCrop(selectorFiles: FileList | null) {
        if (selectorFiles != null) {

            var formData = new FormData();
            for (var key in selectorFiles) {
                formData.append(ImageFileTypes.COVER_PHOTO, selectorFiles[key]);
            }
            this.setState({formData},
                () => this.hasValidFields());
        }
    }

    onSave() {
        this.props.createCrop(this.state.cropName, this.state.formData);
    }

    handleInputGroupChange(newCropName: string) {
        this.setState({
            cropName: newCropName
        }, () => this.hasValidFields());
    }

    hasValidFields() {
        const hasValidText = (this.state.cropName.length > 1);
        const hasValidImages = (this.state.formData.get(ImageFileTypes.COVER_PHOTO) != null)
        this.setState({ hasRequiredFields: (hasValidText && hasValidImages) });
    }

    closeModal() {
        this.setState({
            cropName: '',
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal show={this.props.show}
                   onClose={() => {this.closeModal();}}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            {'Upload Cover Photos'}
                        </h5>
                        (JPEGs. Upload up to 4.)
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>                        
                </Modal.Header>
                <Modal.Body>
                    <div className="coverPhotoContainer">
                        <div className="coverPhotoInputContainer">
                            <div>
                                <b>Photo/Crop Name:  </b>
                                <input
                                    placeholder="Photo/Crop Name"
                                    maxLength={100}
                                    value={this.state.cropName}
                                    onChange={e => {
                                        this.handleInputGroupChange(e.target.value);
                                    } }/>
                            </div>
                        </div>

                        <div className="coverPhotoInputContainer">
                            <label>
                                <b>Image(s)</b>
                            </label>
                            <input type="file"
                            className="filepond"
                            multiple data-max-files="4"
                            accept="image/jpg, image/jpeg"
                            onChange={(e) => this.handleChangeCrop(e.target.files)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/CreateCoverPhotoModal/CreateCoverPhotoModal.tsx